import bot_gif from "../assets/img/bot2.gif"
import wa from "../assets/img/wa.png"

const whatsappLink = "https://wa.me/6281990011688"

const openWhatsApp = () => {
  window.open(whatsappLink, "_blank", "noopener,noreferrer")
}

const WaChat = () => {
  return (
    <div
      className="bot-wa"
      role="button"
      tabIndex={0}
      onClick={openWhatsApp}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault()
          openWhatsApp()
        }
      }}
    >
      <div className="wa-bubble">
        <span className="text-brand">
          Ada yang bisa <span className="text-brand2">TEMI </span>bantu?
        </span>
        <img src={wa} className="wa-icon" alt="" />
      </div>
      <img src={bot_gif} className="img-bot" alt="" />
    </div>
  )
}

export default WaChat
